import appApi from "@/app/api";
import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import { TPreviousDayStatus } from "../types.dashboard";

/** Amounts in cents. */
export interface InvoiceHistoryItem {
  invoice_id: string;
  /** Sequence within the subscription; orders invoices that share a date. */
  rank: number;
  date: string; // YYYY-MM-DD
  plans: string[];
  interval: string;
  coupon?: string;
  amount: number;
  discount_amount: number;
  amount_paid: number;
  trial_start_date?: string;
  trial_end_date?: string;
  previous_day_status: TPreviousDayStatus | "";
  billing_reason: string;
  total: number;
  tax: number;
  starting_balance: number;
  ending_balance: number;
  currency: string;
  created_at: string;
  period_start: string;
  period_end: string;
}

export interface InvoiceHistoryFilters {
  subscription_id?: string;
  billing_reason?: readonly string[];
  interval?: "month" | "year";
}

interface InvoiceHistoryData {
  invoices: InvoiceHistoryItem[];
}

interface GetInvoiceHistoryOption {
  token: string;
  filters?: InvoiceHistoryFilters;
}

type TResponse = TCloudAPIResponse<InvoiceHistoryData>;

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/subscription/invoice-history`;

export async function getInvoiceHistory(
  option: GetInvoiceHistoryOption,
): Promise<TResponse> {
  try {
    const response = await appApi.get(APIURL, {
      headers: {
        Authorization: `Bearer ${option.token}`,
      },
      params: option.filters,
      paramsSerializer: { indexes: null },
    });

    return response.data as TResponse;
  } catch (error: any) {
    console.error("Error fetching invoice history:", error);
    throw error;
  }
}
